/* eslint-disable no-console */

export function log(message: string, severity: string = "info") {
	// if (import.meta.env.PROD) return;

	if (severity === "info") {
		console.log(message);
	} else if (severity === "warning") {
		console.warn(message);
	} else if (severity === "error") {
		console.error(message);
	} else {
		console.log(message);
	}
}
